import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PaymentService } from '@api/backend';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { ErrorResponse } from '@core/models';
import { paymentActions } from '@app2/store/payment/payment.actions';
import { PaymentModes } from '@store/payment';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { DOCUMENT } from '@angular/common';



@Injectable()
export class PaymentEffects {

  public getTypes = createEffect(() => {
    return this.actions$.pipe(
      ofType(paymentActions.getTypes),
      switchMap(() => this.paymentService.getPaymentTypesPaymentTypesGet().pipe(
        map(({ data }) => paymentActions.getTypesSuccess({ data: data.charge_types })),
        catchError((error: unknown) => of(paymentActions.getTypesFailure({ error: error as ErrorResponse }))),
      )),
    );
  });

  public getCurrencies = createEffect(() => {
    return this.actions$.pipe(
      ofType(paymentActions.getCurrencies),
      switchMap(() => this.paymentService.getCurrenciesPaymentCurrenciesGet().pipe(
        map(({ data }) => paymentActions.getCurrenciesSuccess({ data: data.currencies })),
        catchError((error: unknown) => of(paymentActions.getCurrenciesFailure({ error: error as ErrorResponse }))),
      )),
    );
  });

  public charge = createEffect(() => {
    return this.actions$.pipe(
      ofType(paymentActions.charge),
      switchMap(({ payment_type, amount, post_action }) => this.paymentService.chargeBalancePaymentPaymentTypeChargeGet(payment_type, amount, post_action).pipe(
        map(({ data }) => paymentActions.chargeSuccess({ data })),
        catchError((error: unknown) => of(paymentActions.chargeFailure({ error: error as ErrorResponse }))),
      )),
    );
  });

  public chargeSuccess = createEffect(() => {
    return this.actions$.pipe(
      ofType(paymentActions.chargeSuccess),
      tap(({ data }) => {
        if (data.field === PaymentModes.InvoiceLink) {
          this.analystService.logEvent(AnalyticsEventsEnum.UpBalanceApplyTap).then();
          this.document.defaultView?.open(data.invoice_link, '_self');
        }
        if (!!data.volet_params) {
          const form = this.document.createElement('form');
          form.method = 'POST';
          form.action = (data.volet_params as any).form_redirect_url;

          Object.entries(data.volet_params).forEach(([key, value]) => {
            const input = this.document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
          });

          this.document.body.appendChild(form);
          form.submit();
        }
        //
      }),
    );
  }, { dispatch: false });

  constructor(
    private actions$: Actions,
    private paymentService: PaymentService,
    private analystService: AnalystService,
    @Inject(DOCUMENT)
    private document: Document,
  ) {}
}
